export type GuestStatus =
  | "accepted"
  | "accept_pending_quorum"
  | "negotiation_in_progress"
  | "waiting_for_first_response"
  | "away"
  | "cancelled"
  | "declined"
  | "host_intervened"
  | "no_response"
  | "paused"
  | "requires_host_intervention"
  | "responded_unknown_intent"
  | "staging"
  | "undeliverable";

export interface GuestStatusOption {
  label: string;
  value: GuestStatus;
}

export const GuestStatusOptions: GuestStatusOption[] = [
  { label: "Accepted", value: "accepted" },
  { label: "Accept Pending Quorum", value: "accept_pending_quorum" },
  { label: "AI Negotiation", value: "negotiation_in_progress" },
  { label: "Awaiting Response", value: "waiting_for_first_response" },
  { label: "Away", value: "away" },
  { label: "Cancelled", value: "cancelled" },
  { label: "Declined", value: "declined" },
  { label: "Host Intervened", value: "host_intervened" },
  { label: "No Response", value: "no_response" },
  { label: "Paused", value: "paused" },
  {
    label: "Requires Host Intervention",
    value: "requires_host_intervention",
  },
  { label: "Responded Unknown Intent", value: "responded_unknown_intent" },
  { label: "Staging", value: "staging" },
  { label: "Undeliverable", value: "undeliverable" },
];

export function guestStatusOptionFromValue(
  status: string,
): GuestStatusOption | null {
  return GuestStatusOptions.find((o) => o.value === status) || null;
}

export function isValidGuestStatus(status: string): boolean {
  return GuestStatusOptions.find((o) => o.value === status) !== undefined;
}

export function getGuestStatusBackgroundColor(status: GuestStatus): string {
  switch (status) {
    case "accepted":
      return "#70AF80";
    case "accept_pending_quorum":
      return "#70AF80";
    case "negotiation_in_progress":
      return "#7fa2bd";
    case "waiting_for_first_response":
      return "#9bbdec";
    case "away":
      return "#d9d4c9";
    case "cancelled":
      return "#7e8295";
    case "declined":
      return "#7f92a6";
    case "host_intervened":
      return "#81a1d5";
    case "no_response":
      return "#959393";
    case "paused":
      return "#b4c6e2";
    case "requires_host_intervention":
      return "#7aa6ea";
    case "responded_unknown_intent":
      return "#61d1e3";
    case "staging":
      return "#c6d5ee";
    case "undeliverable":
      return "#7e8295";
    default:
      return "lightgray";
  }
}
